import React from "react";
// REDUX
import { useSelector } from "react-redux";
// ELEVATOR ICONS ELEVATOR STATUS
import elDown from "../../../assets/icons/elevatorStatus/el-down.svg";
import elUp from "../../../assets/icons/elevatorStatus/el-up.svg";
import elClose from "../../../assets/icons/elevatorSingle/el-close.svg";
import elOpen from "../../../assets/icons/elevatorSingle/el-open.svg";
import elFrontCloseRearClose from "../../../assets/icons/elevatorDouble/el-front-close-rear-close.svg";
import elFrontCloseRearOpen from "../../../assets/icons/elevatorDouble/el-front-close-rear-open.svg";
import elFrontOpenRearClose from "../../../assets/icons/elevatorDouble/el-front-open-rear-close.svg";
import elFrontOpenRearOpen from "../../../assets/icons/elevatorDouble/el-front-open-rear-open.svg";
import elOpening from "../../../assets/icons/elevatorSingle/el-opening.svg";
import elRearOpening from "../../../assets/icons/elevatorRear/el-opening-rear.svg";

// ESCALATOR ICONS STATUS
import esDownDark from "../../../assets/icons/escalator/es-dark-down-4.svg";
import esDownLight from "../../../assets/icons/escalator/es-light-down-4.svg";
import esUpDark from "../../../assets/icons/escalator/es-dark-up-4.svg";
import esUpLight from "../../../assets/icons/escalator/es-light-up-4.svg";
import esStoppedDark from "../../../assets/icons/escalator/es-dark-stopped.svg";
import esStoppedLight from "../../../assets/icons/escalator/es-light-stopped.svg";
// INTERFACES
import { RootState } from "../../../app/store";
import { LiftType } from "../../../interfaces/Lift.interface";

export default function IconsGetIconByName({
  name,
  liftType,
}: {
  name: string;
  liftType: LiftType;
}) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const ELEVATOR_ICONS_MAP: any = {
    elUp,
    elDown,
    elClose,
    elOpen,
    elFrontCloseRearClose,
    elFrontCloseRearOpen,
    elFrontOpenRearClose,
    elFrontOpenRearOpen,
    elOpening,
    elRearOpening,
    esDownDark,
    esDownLight,
    esUpDark,
    esUpLight,
    esStoppedDark,
    esStoppedLight,
  };

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { theme } = useSelector((state: RootState) => state.home);

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const getTableIcon = (key: string): string => {
    if (liftType === "ELEVATOR") {
      return ELEVATOR_ICONS_MAP[key] ?? "";
    }
    if (liftType === "ESCALATOR") {
      return (
        ELEVATOR_ICONS_MAP[`${key}${theme === "dark" || theme === "blue" ? "Dark" : "Light"}`] ?? ""
      );
    }
    return "";
  };

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div>
      <img src={getTableIcon(name)} alt={name} /> {name}
    </div>
  );
}
